import React from "react";
import PropTypes from "prop-types";
import WarningAmberRoundedIcon from "@mui/icons-material/WarningAmberRounded";
import { TriangleAlert } from "lucide-react";

import { UICallout } from "../../../ui";
import { clx } from "../../../../utils/Helpers";

import "./PaymentNotice.scss";

const DEFAULT_ICONS = {
  warning: <WarningAmberRoundedIcon fontSize="small" />,
  // Figma: a 1px outline. 1.5 on lucide's 24px grid draws 1px at 16px.
  error: <TriangleAlert size={16} strokeWidth={1.5} aria-hidden />,
};

/** Borderless warning (or error) notice of the payment flow: label/md title and message, optional action. */
const PaymentNotice = ({ variant, title, description, icon, action, className }) => (
  <UICallout
    variant={variant}
    hasBorder={false}
    className={clx(
      "payment-notice",
      `payment-notice--${variant}`,
      { "payment-notice--with-action": action },
      className,
    )}
    icon={icon ?? DEFAULT_ICONS[variant]}
    title={title}
    description={description}
    action={action}
  />
);

PaymentNotice.propTypes = {
  variant: PropTypes.oneOf(["warning", "error"]),
  title: PropTypes.node.isRequired,
  description: PropTypes.node,
  icon: PropTypes.node,
  action: PropTypes.node,
  className: PropTypes.string,
};

PaymentNotice.defaultProps = {
  variant: "warning",
  description: null,
  icon: undefined,
  action: null,
  className: undefined,
};

export default PaymentNotice;
